import router from '../../router'
import {PasswordResetConfirm, UserLogin, UserRegister} from "@/gen/openapi-js/src";
import {restAuthApiInstance, tokenApiInstance, userApiInstance} from "../../api/felcana_api";
import {PasswordGrantRequest} from "felcana_api";
import uuid from "uuid";

const FelcanaProApi = require("symptom_checker_api")
const defaultClient = FelcanaProApi.ApiClient.instance
const api_key = defaultClient.authentications["api_key"]

const state = () => ({
    session_id: null,
    answer: null,
    status: "",
    token: "",
    app_token: "",
    user: {
        first_name: "",
        last_name: "",
        email: "",
        password1: "",
        password2: "",
    },
    errors: {},
})

const mutations = {
    save(state, value) {
        state[value.key] = value.value
    },
    update_token(state, value) {
        state.token = value
    },
    error(state, error) {
        if (typeof error === "object" && error !== null) {
            state.errors = error
        }
    },
    register_step_1(state, user) {
        state.user.first_name = user.first_name
        state.user.last_name = user.last_name
        state.token = ""
        state.user.email = ""
        state.user.password1 = ""
        state.user.password2 = ""
        state.errors = {}
    },
    register_step_2(state, email) {
        state.user.email = email
    },
    auth_request(state) {
        state.status = "loading"
    },
    auth_success(state) {
        state.status = "success"
    },
    auth_error(state) {
        state.status = "error"
    },
    logout(state) {
        state.status = ""
        state.token = ""
        state.user.last_name = ""
        state.user.first_name = ""
        state.user.email = ""
        state.user.password1 = ""
        state.user.password2 = ""
        state.errors = {}
    },
}

const actions = {

    async register_step_1({commit}, user) {
        commit("register_step_1", user);
        await router.push({name: process.env.VUE_APP_AUTH_REGISTER_STEP_2});
    },
    async register_step_2({commit, state}, user) {
        commit("register_step_2", user.email);
        let userRegister = new UserRegister(
            user.email,
            user.password1,
            user.password2,
            state.user.first_name,
            state.user.last_name
        );
        await restAuthApiInstance.restAuthRegistrationCreate(userRegister).then(() => {
            router.push({name: process.env.VUE_APP_AUTH_VERIFY_PASSWORD})
        })
            .catch(err => {
                console.log(err);
                commit("error", err.body);
            });
    },

    async login({commit}, userLogin) {
        const passwordGrantRequest = new PasswordGrantRequest(userLogin.password, "password", userLogin.email, uuid())
        commit("auth_request");
        Promise.all([
            restAuthApiInstance.restAuthLoginCreate(userLogin),
            tokenApiInstance.felcanaWebApiHubV1TokenControllerCreate(passwordGrantRequest)
        ]).then(function (responses) {
            // Get a JSON object from each of the responses
            return Promise.all(responses.map(function (response) {
                return response.json();
            }));
        }).then(function (data) {
            // Log the data to the console
            // You would do something with both sets of data here
            console.log(data);
        }).catch(function (error) {
            // if there's an error, log it
            console.log(error);
        });
        await restAuthApiInstance.restAuthLoginCreate(userLogin).then(res => {
            const token = res.key;
            commit("update_token", token);
            commit("auth_success");
            router.push({name: process.env.VUE_APP_DASHBOARD_INDEX});
        })
            .catch(err => {
                commit("auth_error");
                commit("update_token", "");
                console.log(err);
                commit("error", err.body);
            })

    },
    async logout({commit}) {
        commit("logout");
        api_key.apiKey = "";
        await restAuthApiInstance.restAuthLogoutCreate().then(() => {
            router.push({name: process.env.VUE_APP_RT_HOME});
        })
            .catch(err => {
                console.log(err);
            })


    },
    async forgetPassword({state}) {
        await restAuthApiInstance.restAuthPasswordResetCreate({email: state.user.email})
        await router.push({name: process.env.VUE_APP_AUTH_RESET_PASSWORD})
    },
    async resetPassword({commit}, userdata) {
        let userRegister = new PasswordResetConfirm(
            userdata.password,
            userdata.confirm_password,
            userdata.uid,
            userdata.token
        );
        await restAuthApiInstance.restAuthPasswordResetConfirmCreate(userRegister).then(() => {
            commit("logout");  // logout so we can let user re-login with new credentials
            // TODO: notify that password reset was success and allow login
            router.push({name: process.env.VUE_APP_AUTH_LOGIN})
        })
            .catch(err => {
                console.log(err);
                // TODO: display the error from backend in the current view
                commit("error", err.body);
            })
    },
}

const getters = {
    isLoggedIn: state => state.token !== "",
    authStatus: state => state.status,
    user: state => state.user
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
